import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

/**
 * POST /v1/orders/{id}/refresh — on-demand, single-order re-fetch from the marketplace.
 * Backs the order detail page's auto-on-view refresh and its manual
 * "Refresh" button. On success invalidates every query under ["order"] so
 * the detail page re-renders with any changed fields (the order-detail
 * cache key varies by lookup path — by-id vs by-sale-order-id — so a prefix
 * invalidation is required, not one exact key).
 */
export function useRefreshOrder(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const { data, error } = await apiClient.POST("/v1/orders/{id}/refresh", {
        params: { path: { id } },
      });
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["order"] });
    },
  });
}
